import { useState, useEffect } from 'react';

import { DocVisibility } from '@/lib/api';

export const useVisibilityError = (
  text: string,
  visibility: DocVisibility,
  inheritedVisibility?: DocVisibility
) => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Check for mentions, but exclude @feedback since it's not actually tagging a person
    const mentionMatches = text.match(/@(\w+)/g) || [];
    const nonFeedbackMentions = mentionMatches.filter(
      (mention) => mention.toLowerCase() !== '@feedback'
    );
    const hasMentions = nonFeedbackMentions.length > 0;

    if (hasMentions) {
      if (inheritedVisibility === 'private') {
        setError("This thread is private, can't tag friends");
      } else if (visibility === 'private') {
        setError("Can't tag friends in private posts");
      } else {
        setError(null);
      }
    } else {
      setError(null);
    }
  }, [text, visibility, inheritedVisibility]);

  return error;
};
